import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TLocationArticleDM from './TLocationArticleDM'
import TOfficerDocumentDM from './TOfficerDocumentDM'

/**
 * Položky fronty
 */
export default class TQueueItemDM extends Data {
	public static className = 'TQueueItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * Dodatek
	 */
	SupplementId?: number

	/**
	 * Proc
	 */
	Percentage?: number

	/**
	 * Kniha2
	 */
	Book2?: string

	/**
	 * Ci1
	 */
	DocumentRID1?: number

	/**
	 * Kniha1
	 */
	Book1?: string

	/**
	 * Typ
	 */
	RecordTypeId?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * C_Zbo
	 */
	@Type(() => TLocationArticleDM)
	ArticleId?: TLocationArticleDM

	/**
	 * Ci2
	 */
	@Type(() => TOfficerDocumentDM)
	DocumentRID2?: TOfficerDocumentDM
}